export default function PaymentMethodSelector({
  paymentMethod,
  setPaymentMethod
}) {

  return (
    <div className="payment-method">

      <h3>روش پرداخت</h3>

      <label>
        <input
          type="radio"
          value="online"
          checked={paymentMethod === "online"}
          onChange={() => setPaymentMethod("online")}
        />
        پرداخت آنلاین
      </label>

      <label>
        <input
          type="radio"
          value="bank_transfer"
          checked={paymentMethod === "bank_transfer"}
          onChange={() => setPaymentMethod("bank_transfer")}
        />
        حواله بانکی
      </label>

    </div>
  );
}
